{
  "useLongScale": false,
  "baseSeparator": " ",
  "unitSeparator": " ",
  "base": {
    "0": "нөл",
    "1": "бір",
    "2": "екі",
    "3": "үш",
    "4": "төрт",
    "5": "бес",
    "6": "алты",
    "7": "жеті",
    "8": "сегіз",
    "9": "тоғыз",
    "10": "он",
    "11": "он бір",
    "12": "он екі",
    "13": "он үш",
    "14": "он төрт",
    "15": "он бес",
    "16": "он алты",
    "17": "он жеті",
    "18": "он сегіз",
    "19": "он тоғыз",
    "20": "жиырма",
    "30": "отыз",
    "40": "қырық",
    "50": "елу",
    "60": "алпыс",
    "70": "жетпіс",
    "80": "сексен",
    "90": "тоқсан",
    "100": "жүз",
    "200": "екі жүз",
    "300": "үш жүз",
    "400": "төрт жүз",
    "500": "бес жүз",
    "600": "алты жүз",
    "700": "жеті жүз",
    "800": "сегіз жүз",
    "900": "тоғыз жүз"
  },
  "alternativeBase": {},
  "units": [
    {
      "useBaseInstead": true,
      "useBaseException": []
    },
    {
      "singular": "мың",
      "plural": "мың"
    },
    {
      "singular": "миллион",
      "plural": "миллион"
    },
    {
      "singular": "миллиард",
      "plural": "миллиард"
    },
    {
      "singular": "триллион",
      "plural": "триллион"
    },
    {
      "singular": "квадриллион",
      "plural": "квадриллион"
    },
    {
      "singular": "квинтиллион",
      "plural": "квинтиллион"
    },
    {
      "singular": "секстиллион",
      "plural": "секстиллион"
    },
    {
      "singular": "септиллион",
      "plural": "септиллион"
    },
    {
      "singular": "октиллион",
      "plural": "октиллион"
    },
    {
      "singular": "нониллион",
      "plural": "нониллион"
    },
    {
      "singular": "дециллион",
      "plural": "дециллион"
    }
  ],
  "unitExceptions": {
    "1000": "мың"
  }
}